export enum FloorQueryKeys {
  GetFloorPlan = 'GetFloorPlan',
  GetFloor = 'GetFloor',
  GetFloorsSearch = 'GetFloorsSearch',
  GetFloorPlanResources = 'GetFloorPlanResources',
  GetFloorPlanHeatmap = 'GetFloorPlanHeatmap',
}
